/**
 * spm 注册到神策全局（页面级公共属性）：当前页前向来源写入 sensorProvider 的
 * registerPage 页面公共属性，内置全埋点事件（$WebClick/$WebPageLoad/$WebPageLeave
 * 等）与自定义事件一样携带站内来源，与神策 $latest_* 渠道归因互补。
 *
 * 首次注册在 sensorProvider 初始化（registerCommonProperties）中完成；本模块由
 * useEventReportingInit 在路由变化时随 refreshPageReferSpm 一并调用，负责刷新与
 * 清除（无来源页面不能残留上一页的来源）。
 */
import { ReportingCenter } from '../reportingCenter';
import { ProviderType } from '../types';

import { getPageReferSpm } from './spm-session';

/** sensorProvider 刷新页面公共属性的最小接口（避免依赖具体类）。 */
interface SpmPagePropertyProvider {
  refreshSpmPageProperty?(spm: string | undefined): void;
}

export function syncSpmToSensorsPageProperties(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  const provider = ReportingCenter.getInstance().getProvider(ProviderType.SENSORS) as
    | SpmPagePropertyProvider
    | undefined;
  provider?.refreshSpmPageProperty?.(getPageReferSpm());
}
